import { DOMAINS } from '@mm/api-routes';
import DomainModel from '../model/DomainModel';
import AuthenticatedController from './AuthenticatedController';

const mapBEToFE = (model: { connectedPageId: number; domains: string[] }) =>
  ({
    id: model.connectedPageId,
    connectedPageId: model.connectedPageId,
    domainsList: model.domains,
  } as DomainModel);
const mapFEToBE = model => ({
  domains: model.domainsList,
});

class DomainController extends AuthenticatedController {
  static async getAll(pageId: number) {
    const response = await super.get(DOMAINS(pageId));

    // needed to map correctly to FE model
    return mapBEToFE({
      ...response,
      connectedPageId: pageId,
    });
  }

  static async putDomain(pageId: number, domain: DomainModel) {
    const mappedDomain = mapFEToBE(domain);

    const response = await super.put(DOMAINS(pageId), mappedDomain);

    return response.domain;
  }
}

export default DomainController;
